/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { CriticalElementMonitoringDto } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const getCriticalElementMonitoring = (
  userId: string,
  criticalElementId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalElementMonitoringDto>(
    {
      url: `/api/${userId}/critical-elements/${criticalElementId}/monitoring`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetCriticalElementMonitoringQueryKey = (
  userId: string,
  criticalElementId: number
) => {
  return [
    `/api/${userId}/critical-elements/${criticalElementId}/monitoring`,
  ] as const;
};

export const getGetCriticalElementMonitoringQueryOptions = <
  TData = Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCriticalElementMonitoringQueryKey(userId, criticalElementId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCriticalElementMonitoring>>
  > = ({ signal }) =>
    getCriticalElementMonitoring(
      userId,
      criticalElementId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && criticalElementId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCriticalElementMonitoringQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCriticalElementMonitoring>>
>;
export type GetCriticalElementMonitoringQueryError = ErrorType<unknown>;

export function useGetCriticalElementMonitoring<
  TData = Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
          TError,
          Awaited<ReturnType<typeof getCriticalElementMonitoring>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalElementMonitoring<
  TData = Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
          TError,
          Awaited<ReturnType<typeof getCriticalElementMonitoring>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalElementMonitoring<
  TData = Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCriticalElementMonitoring<
  TData = Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementMonitoring>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCriticalElementMonitoringQueryOptions(
    userId,
    criticalElementId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
